import React, { useState, useEffect } from 'react';
import {
  FaFacebookSquare,
  FaLinkedinIn,
  FaInstagram,
  FaBars,
  FaTimes,
} from 'react-icons/fa';
import { IoIosCall } from 'react-icons/io';
import { CgMail } from 'react-icons/cg';
import logo from '../../Assets/images/Frame 39059 1.png';
import { useNavigate } from 'react-router-dom';

const Header = ({ onAboutClick, onContactusClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeNav, setActiveNav] = useState('');
  const navigate = useNavigate(); 

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleHomeClick = (item) => {
    setActiveNav(item);
    navigate('/');
    setIsMenuOpen(false);
  };
  const handleServiceClick = (item) => {
    setActiveNav(item);
    navigate('/services');
    setIsMenuOpen(false);
  };
  const handleAboutClick = (item) => {
     setActiveNav(item);
    navigate('/about');
    setIsMenuOpen(false);
  };

  const handleLoginClick = (item) => {
    setActiveNav(item);
    navigate('/login');
    setIsMenuOpen(false);
  };
  const handleCreateAccountClick = (item) => {
    setActiveNav(item);
    navigate('/signup');
    setIsMenuOpen(false);
  };
  const handleContactUsClick = (item) => {
    setActiveNav(item);
    navigate('/contactUs');
    setIsMenuOpen(false);
  };
  return (
    <header
      // className="w-full bg-gray-100 shadow-md"
      className={`w-full z-50 fixed top-0 left-0 transition-all duration-300 ease-in-out  ${
        isScrolled ? 'bg-opacity-95 shadow-lg' : 'bg-transparent'
      }`}
    >
      {/* Top Header */}
      <div className="md:flex flex md:justify-between justify-around items-center px-2 py-4 md:px-0 xl:px-16 md:py-4 bg-dark-blue md:text-sm text-xs text-white ">
        <div className="md:flex space-x-1 md:space-x-6 container mx-auto">
          <div className="flex items-center space-x-1">
            <IoIosCall className="text-gray-200 ml-2 mt-0" />
            {/* <h6>+8801790188891</h6> */}
            <h6>+880 1897-621262</h6>
          </div>
          <div className="flex items-center space-x-1">
            <CgMail className="text-gray-200 ml-1 mt-0" />
            <h6>support@finwise.com.bd</h6>
          </div>
        </div>
        <div className="flex md:space-x-4 space-x-3 -mt-2 mb-0  text-lg text-gray-200">
          <a href="#">
            <FaFacebookSquare className="hover:text-blue-600" />
          </a>
          <a href="#">
            {' '}
            <IoIosCall className="hover:text-green-500" />
          </a>
          <a href="#">
            <FaLinkedinIn className="hover:text-blue-700" />
          </a>
          <a href="#">
            <FaInstagram className="hover:text-pink-500" />
          </a>
        </div>
      </div>

      {/* Bottom Header / Navbar */}
      <div
        className="w-full  bg-white"
        // className={`w-full ${isScrolled ? 'bg-gray-100 shadow-lg' : ''}`}
      >
        <nav className="flex justify-between items-center md:px-10 px-2 py-2 md:py-2 container mx-auto">
          <div className="flex items-center space-x-0">
            <button onClick={handleHomeClick}>
              <img
                src={logo}
                alt="Logo"
                className="md:h-16 w-36 h-14 md:w-44"
              />
            </button>
          </div>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex pl-20 space-x-10 text-gray-800">
            <li>
              <button
                // onClick={handleServiceClick}
                onClick={() => handleServiceClick('services')}
                // className="hover:text-blue-900 heading"
                className={`${
                  activeNav === 'services' ? 'text-headerBtn' : ''
                } hover:text-headerBtn transition-all duration-300 ease-in-out heading`}
              >
                Our Services
              </button>
            </li>
            <li>
              <button
                // onClick={handleAboutClick}
                onClick={() => handleAboutClick('about')}
                // className="hover:text-blue-900 heading"
                className={`${
                  activeNav === 'about' ? 'text-headerBtn' : ''
                } hover:text-headerBtn transition-all duration-300 ease-in-out heading`}
              >
                About Us
              </button>
            </li>
            <li>
              <button
                // onClick={handleContactUsClick}
                onClick={() => handleContactUsClick('contactUs')}
                // className="hover:text-blue-900 heading"
                className={`${
                  activeNav === 'contactUs' ? 'text-headerBtn' : ''
                } hover:text-headerBtn transition-all duration-300 ease-in-out heading`}
              >
                Contact Us
              </button>
            </li>
          </ul>

          {/* login and register button */}
          <div className="hidden lg:flex space-x-4">
            <button
              onClick={handleLoginClick}
              className="text-sm py-2 px-4 bg-headerBtn text-white rounded-3xl hover:bg-headerBtn button-text"
            >
              Log In
            </button>
            {/* <button
              onClick={handleCreateAccountClick}
              className="text-sm py-2 px-4 text-headerBtn rounded-3xl border-headerBtn border-2 hover:bg-headerBtn hover:text-white button-text"
            >
              Registration
            </button> */}
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-700 focus:outline-none"
            >
              {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </nav>

        {/* Mobile Menu */}
        <div className={`${isMenuOpen ? 'block' : 'hidden'} lg:hidden`}>
          <ul className="flex flex-col space-y-4 text-gray-700 px-4 pb-4 bg-white opacity-95 text-center">
            <li>
              <button
                onClick={handleAboutClick}
                className="hover:text-headerBtn heading"
              >
                About
              </button>
            </li>
            <li>
              <button
                onClick={handleContactUsClick}
                className="hover:text-headerBtn heading"
              >
                Contact
              </button>
            </li>
            <li>
              <button
                onClick={handleServiceClick}
                className="hover:text-headerBtn heading"
              >
                Services
              </button>
            </li>

            {/* login and registraton button  */}
            <button
              onClick={handleLoginClick}
              className="text-sm py-2 px-4 w-20 mx-auto bg-headerBtn text-white rounded-2xl hover:bg-headerBtn heading"
            >
              Log In
            </button>
            {/* <button
              onClick={handleCreateAccountClick}
              className="text-sm py-2 px-4 text-headerBtn rounded-2xl  w-30 mx-auto border-headerBtn border-2 hover:bg-headerBtn hover:text-white heading"
            >
              Registration
            </button> */}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
